export default {
      id: "display-avatar-usage",
      viewBox: "0 0 210 210",
      url: __webpack_public_path__ + "sprite.svg#display-avatar",
      toString: function () {
        return this.url;
      }
    }